import axios from "axios";
import { generateSignedEndpoint } from "../../api/generateSignedEndpoint";
import type { ILiveFile } from "../types/liveFile";

const clientName = (): string =>
	(typeof window !== "undefined" && window.process?.env?.CLIENT_NAME) || "";

export async function fetchPublicLiveFiles(liveId: number): Promise<ILiveFile[]> {
	const signed = await generateSignedEndpoint(`/live/file-live/${liveId}`);
	if (!signed) return [];
	const response = await axios.get(signed, {
		headers: {
			Accept: "application/json",
			"client-name": clientName(),
		},
	});
	const raw = response?.data?.data ?? response?.data;
	if (!Array.isArray(raw)) return [];
	return raw.filter((f: ILiveFile) => {
		if (f == null) return false;
		const p = f.public as boolean | number | undefined;
		if (p === false || p === 0) return false;
		// this route returns audience-visible files; treat missing/1/true as public
		return true;
	});
}
